// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__qqcP9","title":"Info_title__27v7X","selects":"Info_selects__mD5jr","requiredAsterisk":"Info_requiredAsterisk__FTZGA"};